import { MutationTree } from 'vuex';
import { LobbyState } from '@/store/modules/lobby/index';
import {
  SET_CHANGE_PASSWORD_ERRORS,
  SET_CHANGE_PASSWORD_LOADING,
  SET_CHANGE_USER_DATA_CLEANSING_LOADING,
  SET_HELP_DESK_DETAILS,
  SET_INDEX_AND_OFFICES_LIST,
  SET_LOBBY_SUCCESS_DIALOG,
  SET_MUST_CHANGE_PASSWORD,
  SET_MUST_PERFORM_DATA_CLEANSING,
  SET_OPEN_POPUP_CHANGES_NOTIFICATION_FLAG,
  SET_ORG_NEWS, SET_PERFORM_CHANGE_PASSWORD,
  SET_PERFORM_DATA_CLEANSING_ERRORS,
  SET_USER_DATA_CLEANSING_ERRORS,
  SET_USER_PERFORM_DATA_CLEANSING,
} from '@/types/lobby.types';
import { HelpDeskDetailsModel } from '@/models/lobby/helpDeskDetails.model';
import { IndexAndOfficesRequest } from '@/models/request/index-and-offices-request';

export const mutations: MutationTree<LobbyState> = {

  [SET_ORG_NEWS]: (state, orgNews: string[]) => {
    state.orgNews = orgNews;
  },

  [SET_HELP_DESK_DETAILS]: (state, helpDeskDetails: HelpDeskDetailsModel) => {
    state.helpDeskDetails = helpDeskDetails;
  },

  [SET_CHANGE_PASSWORD_ERRORS]: (state, errors: []) => {
    state.changePasswordErrors = errors;
  },

  [SET_USER_DATA_CLEANSING_ERRORS]: (state, errors: []) => {
    state.userDataCleansingErrors = errors;
  },

  [SET_LOBBY_SUCCESS_DIALOG]: (state, lobbySuccessDialog: boolean) => {
    state.lobbySuccessDialog = lobbySuccessDialog;
  },

  [SET_MUST_CHANGE_PASSWORD]: (state, mustChangePassword: boolean) => {
    state.mustChangePassword = mustChangePassword;
  },

  [SET_MUST_PERFORM_DATA_CLEANSING]: (state, mustPerformDataCleansing: boolean) => {
    state.mustPerformDataCleansing = mustPerformDataCleansing;
  },

  [SET_USER_PERFORM_DATA_CLEANSING]: (state, userPerformDataCleansing: boolean) => {
    state.userPerformDataCleansing = userPerformDataCleansing;
  },

  [SET_PERFORM_CHANGE_PASSWORD]: (state, performChangePassword: boolean) => {
    state.performChangePassword = performChangePassword;
  },

  [SET_PERFORM_DATA_CLEANSING_ERRORS]: (state, performDataCleansingErrors: string[]) => {
    state.performDataCleansingErrors = performDataCleansingErrors;
  },

  [SET_CHANGE_PASSWORD_LOADING]: (state, changePasswordLoading: boolean) => {
    state.changePasswordLoading = changePasswordLoading;
  },

  [SET_CHANGE_USER_DATA_CLEANSING_LOADING]: (state, changeUserDataCleansingLoading: boolean) => {
    state.changeUserDataCleansingLoading = changeUserDataCleansingLoading;
  },

  [SET_OPEN_POPUP_CHANGES_NOTIFICATION_FLAG]: (state, openPopupChangesNotificationFlag: boolean) => {
    state.openPopupChangesNotificationFlag = openPopupChangesNotificationFlag;
  },
};
